import React, { JSX, useEffect, useState } from "react";
import Layout from "@/components/layout/Layout";
import CampaignCard from "./components/CampaignCard";
import Icon1 from "@/assets/home/card/Icon1.svg";
import Icon2 from "@/assets/home/card/Icon2.svg";
import Icon3 from "@/assets/home/card/Icon3.svg";
import Icon4 from "@/assets/home/card/Icon4.svg";
import Icon5 from "@/assets/home/card/Icon5.svg";
import Icon6 from "@/assets/home/card/Icon6.svg";
import CardImage from "@/assets/home/a.jpg";
import { OnboardingSuccessDialog } from "./components/OnboardingDialog";
import TextField from "@/components/ui/Textfield";
import { SearchIcon, Loader } from "lucide-react";
import Dropdown from "@/components/ui/DropDown";
import { Plus } from "lucide-react/";
import { Navigate, useNavigate } from "react-router-dom";
import useAuthStore from "@/store/authStore";
import useDashboardStore from "./store/dashboardStore";
import useGlobalStore from "@/store/globalStore";
import Spinner from "@/components/ui/Spinner";

type IconType = {
  src: string;
  alt: string;
  number: number;
};

const icons: IconType[][] = [
  [
    { src: Icon2, alt: "icon 2", number: 0 },
    { src: Icon3, alt: "icon 3", number: 2 },
    { src: Icon4, alt: "icon 4", number: 3 },
  ],
  [
    { src: Icon1, alt: "icon 1", number: 1 },
    { src: Icon6, alt: "icon 6", number: 2 },
    { src: Icon5, alt: "icon 5", number: 0 },
  ],
];

export default function DashboardPage(): JSX.Element {
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const user_role = useAuthStore((state) => state.user_role);
  const { getCampaign, campaignData } = useDashboardStore();
  const setError = useGlobalStore((state) => state.setError);

  const fetchData = async () => {
    setIsLoading(true);
    try {
      await getCampaign();
    } catch (error: any) {
      console.log(error);
      setError(error.message ?? "Something went wrong");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  if (user_role === "Global Admin") return <Navigate to="/teams" />;

  return (
    <Layout>
      <OnboardingSuccessDialog />

      <div className="flex flex-col md:flex-row justify-between items-center gap-4">
        <h1 className="text-2xl md:text-3xl font-semibold text-black mb-4">
          Campaign Dashboard
        </h1>
        <div className="w-full md:w-auto">
          <div className="flex">
            <TextField
              type="text"
              leadingIcon={<SearchIcon size={15} />}
              placeholder="Search By Keywords, Project #"
              className="w-80"
            />
            <Dropdown
              options={[]}
              selected=""
              setSelected={(option) => console.log(option)}
              className="ml-4 w-64"
              placeholder="Filter by Client"
            />
          </div>
        </div>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mt-8">
        <div className="mt-[68px]">
          <div
            className="border border-[#EA33C0] rounded-lg p-8 flex flex-col items-center justify-center text-[#EA33C0] hover:bg-pink-50 transition-colors cursor-pointer h-[330px] shadow-md"
            onClick={() => navigate("/campaign")}
          >
            <Plus className="text-5xl mb-4" />
            <span className="text-lg font-medium">Add campaign</span>
          </div>
        </div>

        {isLoading && (
          <div className="col-span-full flex justify-center items-center h-64">
            <Spinner size={40} />
          </div>
        )}

        {!isLoading &&
          campaignData.length > 0 &&
          campaignData.map((e, index) => (
            <CampaignCard
              imageUrl={e.header_image?.url || CardImage}
              icons={icons}
              onViewClick={() => {
                if (e.campaign.progress_status === "campaign") {
                  navigate(`/campaign/flight?id=${e.campaign.id}`);
                } else if (e.campaign.progress_status === "flight") {
                  navigate(`/campaign/assets?id=${e.campaign.id}`);
                } else if (e.campaign.progress_status === "assets") {
                  navigate(`/campaign/${e.campaign.id}`);
                } else {
                  alert("Campagin Clicked");
                }
              }}
              key={index}
              data={e}
            />
          ))}
      </div>
    </Layout>
  );
}
